export const ACTIONS = {
  UPDATE_SLOT_POPUP_OPENED: 'UPDATE_SLOT_POPUP_OPENED',
  INVALIDATE_SLOT_POPUP_OPENED: 'INVALIDATE_SLOT_POPUP_OPENED',
};

export const updatePopupOpened = data => (dispatch) => {
  dispatch({
    type: ACTIONS.UPDATE_SLOT_POPUP_OPENED,
    payload: data,
  });
};

export const invalidatePopupOpened = () => (dispatch) => {
  dispatch({
  	type: ACTIONS.INVALIDATE_SLOT_POPUP_OPENED,
  });
};
